import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CrossComponentDateValidationService {
  private residencyValidators: Function[] = [];
  private employmentValidators: Function[] = [];

  registerResidencyValidator(validator: Function) {
    this.residencyValidators.push(validator);
  }

  registerEmploymentValidator(validator: Function) {
    this.employmentValidators.push(validator);
  }

  validateDownstreamDates() {
    this.residencyValidators.forEach((validator) => validator());
    this.employmentValidators.forEach((validator) => validator());
  }
}
